import { IFormErrors } from '@interfaces/IFormsErrors';
import { IStudentResults } from '@interfaces/IStudentResults';
import { IUser } from '@interfaces/IUser';
import { Action } from '@ngrx/store';

export enum EStudentResultsViewActions {
  GetStudentResultsRequest = '[Results] Get Student Results Request',
  GetStudentResultsSuccess = '[Results] Get Student Results Success',
  GetStudentResultsFailure = '[Results] Get Student Results Failure',
  ClearStudentResults = '[Results] Clear Students Results',
  WorkAppealRequest = '[Appeal] Post Work Appeal Request',
  WorkAppealSuccess = '[Appeal] Post Work Appeal Success',
  WorkAppealFailure = '[Appeal] Post Work Appeal Failure',
  ClearWorkAppealError = '[Appeal] Clear Work Appeal Error',
  CloseWorkAppealRequest = '[Appeal] Close Work Appeal Request',
  CloseWorkAppealSuccess = '[Appeal] Close Work Appeal Success',
  CloseWorkAppealFailure = '[Appeal] Close Work Appeal Failure',
}

export class GetStudentResultsRequest implements Action {
  public readonly type = EStudentResultsViewActions.GetStudentResultsRequest;

  constructor(public groupId: number, public userId: number) {}
}

export class GetStudentResultsSuccess implements Action {
  public readonly type = EStudentResultsViewActions.GetStudentResultsSuccess;

  constructor(public payload: IStudentResults) {}
}

export class GetStudentResultsFailure implements Action {
  public readonly type = EStudentResultsViewActions.GetStudentResultsFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearStudentResults implements Action {
  public readonly type = EStudentResultsViewActions.ClearStudentResults;
}

export class WorkAppealRequest implements Action {
  public readonly type = EStudentResultsViewActions.WorkAppealRequest;

  constructor(public reviewId: number, public text: string) {}
}

export class WorkAppealSuccess implements Action {
  public readonly type = EStudentResultsViewActions.WorkAppealSuccess;
}

export class WorkAppealFailure implements Action {
  public readonly type = EStudentResultsViewActions.WorkAppealFailure;

  constructor(public error: IFormErrors) {}
}

export class ClearWorkAppealError implements Action {
  public readonly type = EStudentResultsViewActions.ClearWorkAppealError;
}

export class CloseWorkAppealRequest implements Action {
  public readonly type = EStudentResultsViewActions.CloseWorkAppealRequest;

  constructor(public reviewId: number, public reviewer: IUser) {}
}

export class CloseWorkAppealSuccess implements Action {
  public readonly type = EStudentResultsViewActions.CloseWorkAppealSuccess;
}

export class CloseWorkAppealFailure implements Action {
  public readonly type = EStudentResultsViewActions.CloseWorkAppealFailure;

  constructor(public error: IFormErrors) {}
}

export type StudentResultsViewActions =
  | GetStudentResultsRequest
  | GetStudentResultsSuccess
  | GetStudentResultsFailure
  | ClearStudentResults
  | WorkAppealRequest
  | WorkAppealSuccess
  | WorkAppealFailure
  | ClearWorkAppealError
  | CloseWorkAppealRequest
  | CloseWorkAppealSuccess
  | CloseWorkAppealFailure;
